/**
 * Search tools.
 */
H_Tools.search = (() => {
    // console.log('Search tools initialized');

    /**
     * Returns the search results element.
     */
    function getResults() {
        return document.querySelector('.js-faceted-search-results');
    }

    /**
     * Hides the wait button. This should be done after search results have loaded, so that the
     * button cannot be focused manually.
     */
    function hideWaitButton() {
        document
            .querySelector('.js-faceted-search-wait-button')
            ?.classList.remove('-visible');
    }

    /**
     * Shifts focus to the search results.
     */
    function focusResults() {
        // console.log('Focusing results...');

        if (H_Tools.search.requests_active) {
            return;
        }

        const results = getResults();

        if (!results) {
            return;
        }

        const link = results.querySelector('.js-link-collection-link');

        if (link) {
            link.classList.add('js-backwards-focus-ignore');
            link.focus();
            link.classList.remove('js-backwards-focus-ignore');
        }

        /**
         * The first result may not exist, or may not be focusable. In that case, fall back to
         * jumping to the results via the URL hash. Using replace() instead of setting the hash
         * directly, so this doesn't add a new history entry.
         */
        if (!link || document.activeElement !== link) {
            location.replace('#search-results');
        }

        hideWaitButton();
        H_Tools.search.focus_results_on_settle = false;
    }

    /**
     * Shifts focus to the wait button.
     */
    function focusWaitButton() {
        let button = document.querySelector('.js-faceted-search-wait-button');

        if (!button) {
            return;
        }
        button.classList.add('-visible');
        button.focus();
    }

    /**
     * Scrolls the viewport to the search results element.
     */
    function scrollToResults() {
        H_Tools?.stickyheader?.scrollTo(getResults());
    }

    function showResults(e) {
        if (
            H_Tools.search.requests_active ||
            H_Tools.search.results_are_stale
        ) {
            focusWaitButton();

            scrollToResults();
            H_Tools.search.focus_results_on_settle = true;
        } else {
            scrollToResults();
            focusResults();
        }
    }

    // return an object to expose inner functions
    return {
        results_are_stale: false,
        focus_results_on_settle: false,
        requests_active: 0,
        getResults: getResults,
        focusResults: focusResults,
        focusWaitButton: focusWaitButton,
        showResults: showResults,
    };
})();
